(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  function bind(t) {
    if (t.__n1drag) return; t.__n1drag = true;
    var down = false, moved = false, sx = 0, sl = 0;
    t.addEventListener('dragstart', function (e) { e.preventDefault(); });
    t.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || e.target.closest('button,input,select')) return;
      down = true; moved = false; sx = e.clientX; sl = t.scrollLeft;
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var d = e.clientX - sx;
      if (!moved && Math.abs(d) > 5) { moved = true; t.classList.add('is-dragging'); }
      if (moved) { e.preventDefault(); t.scrollLeft = sl - d; }
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      t.classList.remove('is-dragging');
      setTimeout(function () { moved = false; }, 0);
    });
    t.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }
  function init() { document.querySelectorAll('[data-n1-track],[data-n1-together-list],.n1m-hero__t').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
